import { Button, Typography, Divider, TableContainer, Table, TableHead, TableRow, TableBody, Paper, TableCell } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import useApi from "./../../../hooks/useAPI"
import { useSelector, useDispatch } from "react-redux"
import { useState, useEffect } from "react"
import { catEstatusProceso } from "./../../../constant/catEstatusProceso"
import { DIAS_RESTANTES_CAMBIO_PASAJERO } from "./../../../constant/constantes"
import { FormatoFechaIso, FormatoDiffYear } from "../../../utils/FormatFecha"
import { consultaPenalizacionRemovePasajeroAction, consultaPasajerosAction, RemovePasajeroAction, consultaDetalleViajeAction } from "../../../ducks/cambiosDuck"
import { formatDinero } from "../../../utils/formatDinero"
import FNuevoPasajero from "./FNuevoPasajero"
import BackDrop from "../../../global/BackDrop"
export const VCambioPasajerosStyle = makeStyles((theme) => ({
    root: {
        margin: "10px 0",
    },
    content: {
        margin: "20px 0",
    },
    contentButton: {
        margin: "20px 0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    table: {
        minWidth: 650,
    },
}))
const VCambioPasajero = () => {
    const { cliente, viaje, diasRestantes, penalizacion, pasajeros } = useSelector(store => store.cambios)
    const dispatch = useDispatch()
    const classes = VCambioPasajerosStyle()
    const totalPasajeors = useApi(`Trip/Documents/${viaje?.Cuenta?.Id_Cuenta}/${cliente?.paquete?.Id_Paquete}`)
    const [virtuales, setVirtuales] = useState([])
    const [load, setLoad] = useState(false)

    useEffect(() => {
        dispatch(consultaPasajerosAction({ IdPaquete: cliente?.paquete?.Id_Paquete }))
    }, [dispatch, cliente?.paquete?.Id_Paquete])

    useEffect(() => {
        const llenarArray = () => {
            let arrayVirtual = []
            let numAdultos = viaje.Paquete?.Numero_Personas
            let numMenor = pasajeros.supMenor?.Cantidad
            if (numMenor > 0)
                numAdultos = numAdultos - numMenor
            for (let i = 0; i < numAdultos; i++) {
                arrayVirtual.push({
                    idPasajero: `A-${i + 1}`,
                    Nombre: `Pasajero ${i + 1}`,
                    ApellidoPaterno: "",
                    ApellidoMaterno: "",
                    FechaNacimiento: "",
                    Tipo: "Adultos"
                })
            }
            for (let j = 0; j < numMenor; j++) {
                arrayVirtual.push({
                    idPasajero: `M-${j + 1}`,
                    Nombre: `Pasajero menor ${j + 1}`,
                    ApellidoPaterno: "",
                    ApellidoMaterno: "",
                    FechaNacimiento: "",
                    Tipo: "Menores"
                })
            }
            setVirtuales(arrayVirtual)
        }
        if (viaje.Paquete?.Numero_Personas > totalPasajeors.length)
            llenarArray()
        return () => {
            setVirtuales([])
        }
    }, [viaje.Paquete?.Numero_Personas, totalPasajeors.length, pasajeros.supMenor?.Cantidad])

    const onEliminar = ({ psajero, tipo, virtual }) => {
        setLoad(true)
        const payload = {
            IdPaquete: viaje.Paquete?.Id_Paquete,
            [`${tipo}`]: (virtual) ? [0] : [psajero.idPasajero]
        }
        dispatch(consultaPenalizacionRemovePasajeroAction(payload)).then(Response => {
            setLoad(false)
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }

            DialogMessage.fire({
                title: '¿Estas seguro de eliminar este pasajero?',
                html: `Penalizacion: <b>${Response.MontoPenalizacion} ${viaje?.Moneda?.Clave}</b> </br>
                        Nuevo monto paquete: <b>${Response.MontoPaquete} ${viaje?.Moneda?.Clave}</b>`,
                showCancelButton: true,
                confirmButtonText: "Aplicar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    setLoad(true)
                    dispatch(RemovePasajeroAction(payload)).then(Response => {
                        setLoad(false)
                        if (Response.status === 500) {
                            ToastMessage.fire({
                                icon: "error",
                                title: "Ha habido un problema intentar mas tarde",
                            });
                            return null;
                        }
                        if (Response.status === 400) {
                            ToastMessage.fire({
                                icon: "warning",
                                title: Response.Message,
                            });
                            return null;
                        }
                        dispatch(consultaDetalleViajeAction())
                        dispatch(consultaPasajerosAction({ IdPaquete: cliente?.paquete?.Id_Paquete }))
                        ToastMessage.fire(
                            'Se aplico la cancelacion!',
                            '',
                            'success'
                        )
                    })
                }
            })
        })
    }
    if (diasRestantes <= DIAS_RESTANTES_CAMBIO_PASAJERO)
        return <div style={{ textAlign: "center" }}>
            <h2>No es posible cambiar psajeros</h2>
            <h2>Se supero el limete de dias para aplicar este cambio</h2>
        </div>
    if (viaje.Paquete?.CatEstatusProceso === catEstatusProceso.VUELOS)
        return <div style={{ textAlign: "center" }}>
            <h2>No es posible cambiar psajeros</h2>
            <h2>El paquete se encuentra en estatus de aereos</h2>
        </div>
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <Typography variant="body1">
                    Monto por agregar: {`${formatDinero((penalizacion.MontoPaquete - viaje.Paquete.Monto_Paquete > 0) ? penalizacion.MontoPaquete - viaje.Paquete.Monto_Paquete : 0)} ${viaje?.Moneda?.Clave}`}
                </Typography>
                <Typography variant="body1">
                    Monto penalizacion: {`${formatDinero(penalizacion.MontoPenalizacion)} ${viaje?.Moneda?.Clave}`}
                </Typography>
                <Typography variant="body1">
                    Nuevo monto del paquete: {`${formatDinero(penalizacion.MontoPaquete)} ${viaje?.Moneda?.Clave}`}
                </Typography>
            </div>
            <div className={classes.content}>
                <Typography variant="body1">
                    Agregar pasajeros
                </Typography>
            </div>
            <FNuevoPasajero />
            <Divider style={{ backgroundColor: "rgb(105, 163, 59)", height: "3px" }} />
            <div className={classes.content}>
                <Typography variant="body1">
                    Pasajeros existentes
                </Typography>
            </div>
            <div>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Nombre</TableCell>
                                <TableCell align="center">Fecha de nacimiento</TableCell>
                                <TableCell align="center">Tipo</TableCell>
                                <TableCell align="center">Documentos</TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                virtuales.map((psajero, index) =>
                                    <TableRow key={psajero.idPasajero}>
                                        <TableCell align="center">{`${psajero.Nombre} ${psajero.ApellidoPaterno} ${psajero.ApellidoMaterno}`}</TableCell>
                                        <TableCell align="center">{FormatoDiffYear({ date: psajero.FechaNacimiento })}</TableCell>
                                        <TableCell align="center">{psajero.Tipo}</TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"><Button variant="contained" onClick={() => onEliminar({ psajero, tipo: psajero.Tipo, virtual: true })}>Quitar</Button></TableCell>
                                    </TableRow>)
                            }
                            {
                                pasajeros?.Adultos?.Pasajeros.map((psajero, index) =>
                                    <TableRow key={psajero.idPasajero}>
                                        <TableCell align="center">{`${psajero.Nombre} ${psajero.ApellidoPaterno} ${psajero.ApellidoMaterno}`}</TableCell>
                                        <TableCell align="center">{FormatoFechaIso({ date: psajero.FechaNacimiento, formato: "dd MMMM yyyy" })}</TableCell>
                                        <TableCell align="center">Adultos</TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"><Button variant="contained" onClick={() => onEliminar({ psajero, tipo: 'Adultos', virtual: false })}>Quitar</Button></TableCell>
                                    </TableRow>)
                            }
                            {
                                pasajeros?.Menores?.Pasajeros.map((psajero, index) =>
                                    <TableRow key={psajero.idPasajero}>
                                        <TableCell align="center">{`${psajero.Nombre} ${psajero.ApellidoPaterno} ${psajero.ApellidoMaterno}`}</TableCell>
                                        <TableCell align="center">{FormatoFechaIso({ date: psajero.FechaNacimiento, formato: "dd MMMM yyyy" })}</TableCell>
                                        <TableCell align="center">Menores</TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"><Button variant="contained" onClick={() => onEliminar({ psajero, tipo: 'Menores', virtual: false })}>Quitar</Button></TableCell>
                                    </TableRow>)
                            }
                            {
                                pasajeros?.Infantiles?.Pasajeros.map((psajero, index) =>
                                    <TableRow key={psajero.idPasajero}>
                                        <TableCell align="center">{`${psajero.Nombre} ${psajero.ApellidoPaterno} ${psajero.ApellidoMaterno}`}</TableCell>
                                        <TableCell align="center">{FormatoFechaIso({ date: psajero.FechaNacimiento, formato: "dd MMMM yyyy" })}</TableCell>
                                        <TableCell align="center">Infantes</TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"><Button variant="contained" onClick={() => onEliminar({ psajero, tipo: 'Infantes', virtual: false })}>Quitar</Button></TableCell>
                                    </TableRow>)
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <BackDrop open={load} />
        </div>
    )
}
export default VCambioPasajero